import { WSQueryConfig } from "@ws-react-query";
import { useWSQuery } from "../../helpers";
import { QUERY_EMPLOYEE_TAX_FORM_SCHEMA_WITH_VALUES } from "../keys";
import { employeeTaxFormsService } from "../../../services/employeeTaxForms";
import { IGetFormSchemaResponse } from "../../../modules/EmployeeTaxForms/types";
import { WSServiceError } from "../../../utils/serviceHelper";

type Params = {
  formInstanceId: string;
  values: Record<string, unknown>;
};

const stableHash = (values: Record<string, unknown>): string => {
  try {
    return JSON.stringify(
      Object.keys(values)
        .sort()
        .reduce<Record<string, unknown>>((acc, k) => {
          acc[k] = values[k];
          return acc;
        }, {})
    );
  } catch {
    return "";
  }
};

export const useQueryEmployeeTaxFormSchemaWithValues = (
  params: Params,
  queryConfig?: WSQueryConfig<IGetFormSchemaResponse, WSServiceError>
) =>
  useWSQuery<IGetFormSchemaResponse, WSServiceError>(
    [
      QUERY_EMPLOYEE_TAX_FORM_SCHEMA_WITH_VALUES,
      params.formInstanceId,
      stableHash(params.values)
    ],
    () =>
      employeeTaxFormsService.getSchema({
        formInstanceId: params.formInstanceId,
        values: params.values
      }),
    {
      enabled: !!params.formInstanceId,
      ...queryConfig
    }
  );
